export const getEventTags = item => {
  // eventCategories
  let tagList = [];
  item.eventType && tagList.push(item.eventType);
  item.eventCategories && item.eventCategories.length > 0 && tagList.push(item.eventCategories[0]);
  return tagList;
}